import { Descriptions, Divider, Flex, Text } from '@procurify/ui'

import { useFeatureFlag, useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { BudgetCategoryAttributeDescriptionsStyled } from './styles/BudgetCategoryAttributeDescriptionsStyled'

const ATTRIBUTE_VALUE_SEPARATOR = ' | '

export interface IBudgetCategoryAttributeDescription {
  label: string
  value: string[]
}

export interface IBudgetCategoryAttributeDescriptionsProps {
  attributes: IBudgetCategoryAttributeDescription[]
  secondaryAttributes?: IBudgetCategoryAttributeDescription[]
  isSourceOfTruth?: boolean
}

const renderAttributeAsText = (attributes: string[]) => {
  if (!attributes || !attributes.length) return <Text inline>--</Text>
  return attributes.map((attribute, index) => (
    <span key={`${attribute}-${index}`} className='attribute-wrapper'>
      <Text inline>{attribute}</Text>
      {index === attributes.length - 1 || ', '}
    </span>
  ))
}

export const BudgetCategoryAttributeDescriptions = ({
  attributes,
  secondaryAttributes,
  isSourceOfTruth,
}: IBudgetCategoryAttributeDescriptionsProps) => {
  const intl = useProcurifyIntl()
  const PUR_4252_BUDGET_BY_CUSTOM_FIELDS = useFeatureFlag(
    'PUR_4252_BUDGET_BY_CUSTOM_FIELDS'
  )

  const renderAttributeValue = (value: string[]) => {
    if (!PUR_4252_BUDGET_BY_CUSTOM_FIELDS) {
      return <Flex.Row spacing={0}>{renderAttributeAsText(value)}</Flex.Row>
    }
    return value?.length ? value.join(ATTRIBUTE_VALUE_SEPARATOR) : null
  }

  const renderAttributes = (
    attributesToRender: IBudgetCategoryAttributeDescription[]
  ) =>
    attributesToRender.map(({ label, value }) => (
      <Descriptions.Item label={label} key={`${label}-attribute`}>
        {renderAttributeValue(value)}
      </Descriptions.Item>
    ))

  return (
    <BudgetCategoryAttributeDescriptionsStyled>
      <Descriptions>
        {renderAttributes(attributes)}
        {secondaryAttributes && (
          <>
            <Divider />
            {renderAttributes(secondaryAttributes)}
          </>
        )}
        {isSourceOfTruth !== undefined && (
          <Descriptions.Item
            label={intl.formatMessage(messages.sourceOfTruthLabel)}
          >
            {intl.formatMessage(
              isSourceOfTruth ? messages.yesText : messages.noText
            )}
          </Descriptions.Item>
        )}
      </Descriptions>
    </BudgetCategoryAttributeDescriptionsStyled>
  )
}

BudgetCategoryAttributeDescriptions.displayName =
  'BudgetCategoryAttributeDescriptions'
